import React from 'react';
import type { PapiDeviation } from '@wix/da-papi-types';
import ThumbOverlayDefault from '@wix/da-ds/pkg/thumbs/ThumbOverlayDefault';
import { isVideoOrGif, getVideoDuration } from '../../../../utils/deviations';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import { isMultiImageDeviation } from '../../../_helpers';
import { useDeviationBlockType } from '../../hooks/useDeviationBlockType';
import DeviationThumbStatusIndicators from '../DeviationThumbIndicators';

interface Props {
  deviation: PapiDeviation;
  width?: number;
  height?: number;
  isFaved?: boolean;
  hasCommentedOn?: boolean;
  className?: string;
}

const DeviationThumbOverlayDefault: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  width,
  height,
  isFaved,
  hasCommentedOn,
  children,
  className,
}) => {
  const blockType = useDeviationBlockType(deviation);
  const { showPermanentEngagementIcon, showMediaIndicators } = useOverlayContext(deviation);

  return (
    <ThumbOverlayDefault
      width={width}
      height={height}
      isFaved={showPermanentEngagementIcon && isFaved}
      isCommented={showPermanentEngagementIcon && hasCommentedOn}
      statusIndicators={!blockType && <DeviationThumbStatusIndicators deviation={deviation} />}
      isMultiImage={isMultiImageDeviation(deviation)}
      mediaIndicator={showMediaIndicators && !blockType ? isVideoOrGif(deviation) : undefined}
      duration={getVideoDuration(deviation)}
      className={className}
    >
      {children}
    </ThumbOverlayDefault>
  );
};
DeviationThumbOverlayDefault.displayName = 'DeviationThumbOverlayDefault';

export default DeviationThumbOverlayDefault;
